import { useLayoutEffect, useState } from 'react';

const CONTENT_AREA_ID = 'content_wrapper';

interface Bounds {
  left: number;
  width: number;
}

export const useContentAreaBounds = () => {
  const [bounds, setBounds] = useState<Bounds>();

  useLayoutEffect(() => {
    const element = document.getElementById(CONTENT_AREA_ID);
    if (!element) {
      return undefined;
    }

    const updateBounds = () => {
      const { left, width } = element.getBoundingClientRect();
      setBounds((previous) =>
        previous?.left === left && previous.width === width ? previous : { left, width }
      );
    };
    updateBounds();

    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const observer = new ResizeObserver(updateBounds);
    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return bounds;
};
